module.exports = __webpack_public_path__ + "img/Weapon_124.d876da7a.png";